import { render, staticRenderFns } from "./AdSmsNotice.vue?vue&type=template&id=1208ae88&scoped=true&"
import script from "./AdSmsNotice.vue?vue&type=script&lang=ts&"
export * from "./AdSmsNotice.vue?vue&type=script&lang=ts&"
import style0 from "./AdSmsNotice.vue?vue&type=style&index=0&id=1208ae88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1208ae88",
  null
  
)

export default component.exports